import { graphql } from 'react-apollo';
import { SimpleGraphQLComponent, loadMorePaginationProp } from '../../utils/apollo';
import isEmpty from 'lodash/isEmpty';

import CollegeEvents from './collegeEvents';
import fetchCollegeEventsQuery, { studentProfile, COLLEGE_EVENTS_PAGE_SIZE } from './graphql/fetchCollegeEvents';
import fetchMajorsQuery from './graphql/fetchMajors';
import fetchRecommendedEventsCountQuery from './graphql/fetchRecommendedEvents';
import get from 'lodash/get';

const eventsData = graphql(fetchCollegeEventsQuery, {
  skip: (props) => isEmpty(props.userInfo),
  options: /* istanbul ignore next */ (props) => ({
    variables: {
      first: COLLEGE_EVENTS_PAGE_SIZE,
      studentProfile: studentProfile(props.userInfo.userData),
    },
  }),
  props: loadMorePaginationProp(fetchCollegeEventsQuery),
});

const majorsData = graphql(fetchMajorsQuery, {
  name: 'majorsData',
});

const recommendedEventsData = graphql(fetchRecommendedEventsCountQuery, {
  name: 'recommendedEventsData',
  skip: (props) => isEmpty(props.userInfo) || get(props, 'userInfo.userData.coppa', false),
  options: /* istanbul ignore next */ (props) => ({
    errorPolicy: 'all',
    variables: {
      studentProfile: studentProfile(props.userInfo.userData),
    },
  }),
});

export default SimpleGraphQLComponent(eventsData, majorsData, recommendedEventsData)(CollegeEvents);
